<template>
    <div>
        <GmapMap
            v-if="isIndonesia"
            :center="{ lat: -2.5489, lng: 118.0149 }"
            :zoom="4"
            :options="mapOptions"
            style="width: 100%; height: 500px"
            @tilesloaded="onMapReady"
            ref="myMapRef"
        >
        </GmapMap>
        <GoogleMapProvince
            :name="provinceName"
            :status="status"
            :masterLegend="masterLegend"
            v-else
        />
        <div
            class="map-legend"
            :class="{ closed: isLegendClosed }"
            ref="mapLegend"
        >
            <span class="toggle-legend" @click="toggleLegend">
                <i v-if="isLegendClosed" class="fa fa-angle-right fa-lg"></i>
                <i v-else="isLegendClosed" class="fa fa-angle-left fa-lg"></i>
            </span>
            <!-- <h3>Legend</h3> -->
            <template v-if="status == 'all result'">
                <div class="mt-3">
                    <span style="background-color: green"></span> Majority
                    Genuine
                </div>
                <div class="mt-3">
                    <span style="background-color: red"></span> Majority
                    Counterfeit
                </div>
            </template>

            <template v-else>
                <div
                    v-for="(legend, index) in masterLegend[status]"
                    :class="{ 'mt-3': index > 0 }"
                >
                    <span :style="{ border: index === masterLegend[status].length - 1 ? '1px solid #ccc' : 'none', 'background-color': legend.color }"></span>
                    {{ legend.filter }}
                </div>
                <!-- <div class="mt-3"><span style="background-color: red;"></span> Majority Counterfeit</div>
            <div class="mt-3"><span style="background-color: green;"></span> Majority Genuine</div> -->
            </template>
        </div>
    </div>
</template>

<script>
import * as VueGoogleMaps from "vue2-google-maps";
import indonesiaGeoJson from "@/assets/adm_1.json"; // Import GeoJSON data
import GoogleMapProvince from "./GoogleMapProvince.vue";
import { mapActions, mapState } from "vuex";

export default {
    name: "IndonesiaMap",

    components: {
        GoogleMapProvince,
        GmapMap: VueGoogleMaps.Map,
    },
    props: ["data", "masterLegend", "status"],

    data() {
        return {
            zoomList: [],
            mapOptions: {
                styles: [
                    {
                        featureType: "all",
                        elementType: "all",
                        stylers: [{ visibility: "off" }], // Turn off visibility of all map features
                    },
                    {
                        featureType: "landscape",
                        elementType: "geometry",
                        stylers: [{ visibility: "on" }, { color: "#e3f1f2" }], // White background
                    },
                ],
                mapTypeControl: false,
                streetViewControl: false,
                // disableDefaultUI: true // Optional: to remove map controls
            },
            isLegendClosed: false,
            provinceKeys: [],
            boundaries: [],
            provinceName: "",
            //isIndonesia: true
        };
    },

    computed: {
        ...mapState("maps", {
            isIndonesia: (state) => state.isIndonesia,
        }),
    },
    mounted() {
        console.log("total ", this.zoomList.length);
    },
    created() {
        console.log("Data received: ", this.data);
        this.data.forEach((e) => {
            this.zoomList.push({
                name: e.nama_provinsi,
                zoom_level: e.zoom_level,
            });
        });

        const requireAssets = require.context(
            "@/assets/provinsi",
            false,
            /\.(json)$/
        );
        this.provinceKeys = requireAssets.keys();
        this.boundaries = requireAssets.keys().map(requireAssets);
    },

    methods: {
        onMapReady(location = null) {
            this.$refs.myMapRef.$mapPromise.then((map) => {
                if (location == null) {
                    map.data.addGeoJson(indonesiaGeoJson);
                } else {
                    let key = this.provinceKeys.findIndex((testing) =>
                        testing.includes(location)
                    );
                    map.data.addGeoJson(this.boundaries[key]);
                }

                map.data.setStyle((feature) => {
                    let myFeature = feature.getProperty("ADM1_PCODE");
                    let selectedData = this.data.find(
                        (x) => x.kode_provinsi === myFeature
                    );
                    let color = "white"; // Default color

                    if (this.status === "all result") {
                        if (selectedData) {
                            let total_scan = parseInt(selectedData.total_scan);
                            let percentage = parseFloat(
                                selectedData.percentage
                            );
                            if (total_scan === 0) {
                                color = "white";
                            } else if (percentage >= 50) {
                                color = "green";
                            } else {
                                color = "red";
                            }
                        }
                    } else {
                        let legend = this.masterLegend[this.status];
                        if (selectedData) {
                            let percentage = parseFloat(
                                selectedData.percentage
                            );
                            color = this.getColorForValue(percentage, legend);
                        }
                    }

                    return {
                        fillColor: color,
                        fillOpacity: 1, // Set fill opacity to 1 for maximum opacity
                        strokeColor: "black",
                        strokeOpacity: 1, // Set stroke opacity to 1 for maximum opacity
                        strokeWeight: 1,
                    };
                });

                const infoWindow = new google.maps.InfoWindow();

                // Mouseover event listener
                map.data.addListener("mouseover", (event) => {
                    let feature = event.feature;
                    let myFeature = feature.getProperty("ADM1_PCODE");
                    let selectedData = this.data.find(
                        (x) => x.kode_provinsi === myFeature
                    );

                    // console.log("selected data:", selectedData);
                    

                    let description = `
        <div class="row" style="min-width:250px;min-height:50px">
          <div class="col-3" style="display:flex;align-items:center;justify-content:center">
            <div>
              <h5>${parseInt(selectedData ? selectedData.percentage : 0)} %</h5>
            </div>
          </div>
          <div class="col-9 pr-3">
            <h5>${feature.getProperty("ADM1_EN")}</h5>
            ${
                selectedData
                    ? `${
                          selectedData.genuine || selectedData.genuine === 0
                              ? selectedData.genuine + " Genuine "
                              : selectedData.counterfeit + " Counterfeit "
                      } out of ${selectedData.total_scan} Scan`
                    : ""
            }
          </div>
        </div>
      `;

                    infoWindow.setContent(description);
                    infoWindow.setPosition(event.latLng);
                    infoWindow.setOptions({
                        pixelOffset: new google.maps.Size(0, -30),
                    });
                    infoWindow.open(map);
                });

                // Click event listener
                map.data.addListener("click", (event) => {
                    var latLng = event.latLng;
                    var lat = latLng.lat();
                    var lng = latLng.lng();
                    var shortName = event.feature.getProperty("ADM1_EN");

                    this.provinceName = shortName;
                    this.updateIsIndonesia(false);
                    this.updateNamaProvinsi(shortName);
                    this.settingCenter({ lat: lat, lng: lng });
                    this.updateKodeProvinsi(
                        event.feature.getProperty("ADM1_PCODE")
                    );

                    let index = this.zoomList.findIndex(
                        (item) =>
                            item.name ===
                            event.feature.getProperty("ADM1_EN").toUpperCase()
                    );
                    if (index === -1) {
                        this.settingZoomLevel(8);
                    } else {
                        if (this.zoomList[index].zoom_level === 0) {
                            this.settingZoomLevel(8);
                        } else {
                            this.settingZoomLevel(
                                this.zoomList[index].zoom_level
                            );
                        }
                    }
                });

                // Mouseout event listener to close the info window
                map.data.addListener("mouseout", () => {
                    infoWindow.close();
                });

                const legend = this.$refs.mapLegend;
                map.controls[google.maps.ControlPosition.LEFT_BOTTOM].push(
                    legend
                );
            });
        },
        toggleLegend() {
            this.isLegendClosed = !this.isLegendClosed;
        },
        getColorForValue(value, legend) {
            for (const item of legend) {
                if (
                    (item.min === undefined || value >= item.min) &&
                    (item.max === undefined || value <= item.max)
                ) {
                    return item.color;
                }
            }
            return null; // Return null or a default color if no match is found
        },
        ...mapActions("maps", [
            "updateIsIndonesia",
            "updateNamaProvinsi",
            "settingCenter",
            "updateKodeProvinsi",
            "settingZoomLevel",
        ]),
    },
};
</script>

<style>
.map-legend {
    background: white;
    padding: 10px;
    margin: 10px;
    border: 1px solid #C7C7C7;
    position: absolute;
    bottom: 30px !important;
    left: 10px;
    transition: all 0.3s ease;
    width: 200px;
    z-index: 5;
    font-size: 12px;
    font-family: 'Inter', sans-serif;
    color: #383838;
}

.toggle-legend {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    padding: 5px 10px;
    background-color: white;
    border-left: none;
    z-index: 10;
}

.map-legend.closed {
    width: 30px;
    overflow: visible;
}

.map-legend h3,
.map-legend div {
    display: none;
    /* Hide when closed */
}

.map-legend.closed h3,
.map-legend.closed div {
    display: none;
    /* Ensure content is hidden when closed */
}

.map-legend:not(.closed) h3,
.map-legend:not(.closed) div {
    display: block;
    /* Display content when legend is not closed */
}

/* Adjust this based on the actual width of your toggle button */
.map-legend.closed {
    width: 30px;
    /* Adjust width to fit the toggle button */
    overflow: visible;
    /* Set overflow to visible so the button is not cut off */
}

.map-legend div span {
    display: inline-block;
    width: 15px;
    /* Width of the square */
    height: 15px;
    /* Height of the square */
    margin-right: 5px;
    /* Space between the square and text */
    vertical-align: middle;
    /* Align the square with the text */
    border: 1px solid black;
}

/* Optional: Style for the square colors */
.map-legend div:nth-child(1) span {
    background-color: white;
}

.map-legend div:nth-child(2) span {
    background-color: red;
}

.map-legend div:nth-child(3) span {
    background-color: green;
}
</style>
